import { createContext } from "react";

// Context for passing the `<ProjectDetail />` overlay ref to the `<ViewerOverlayNotice />`.
export const ViewerOverlayContext = createContext<HTMLDivElement | null>(null);
